import React from "react";
import { HiOutlineExternalLink } from "react-icons/hi";

const StripeDashboardLink = ({
  href,
  children,
  className = "inline-flex items-center gap-1 text-xs font-medium text-indigo-600 hover:text-indigo-700",
  title = "Open in Stripe Dashboard",
  showIcon = true,
}) => {
  if (!href) {
    return children ?? null;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={className}
      title={title}
      onClick={(event) => event.stopPropagation()}
    >
      <span>{children}</span>
      {showIcon ? <HiOutlineExternalLink className="h-3.5 w-3.5 shrink-0" aria-hidden="true" /> : null}
    </a>
  );
};

export default StripeDashboardLink;
